import React from 'react';
import { Link } from 'react-router';
import AddButton from 'focus_groups/containers/add_button';
import Meta from 'project/containers/meta';
import AddModals from 'focus_groups/containers/add_modals';

const FocusGroups = ({ hasGroups }) => (
  <div className="focus-groups small-16 columns">
    <Meta title="Focus Groups" />
    <div className="empty-state no-results">
      <div className="empty-state-content">
        <h3>Make Smarter Decisions</h3>

        <p>
          Pick your favorite 12 designs and invite colleagues, customers, and others to comment
          and<br className="break-for-medium-up"/> vote on the designs they like. You can launch a
          focus group at any time, but you'll get more<br className="break-for-medium-up"/> value
          if you wait until all designs have been submitted and the project ends.
          For help running<br className="break-for-medium-up"/> a focus group, check out
          the <Link target="_blank" to="/help/managing-project/what-is-a-focus-group/">
          Focus Group Guide</Link>.
        </p>

        <div className="empty-state-cta">
          { !hasGroups && <h3>You haven&apos;t created any focus groups.</h3> }
          <AddButton hasGroups={hasGroups}/>
        </div>
      </div>
    </div>
    <AddModals/>
  </div>
);

export default FocusGroups;



// WEBPACK FOOTER //
// ./focus_groups/components/index.jsx